import Breadcrumb from "components/Common/Breadcrumb"
import FullPageLoader from "components/fullPageLoader"
import useFetchKycData from "hooks/useFetchKycData"
import React from "react"
import {
  Card,
  Col,
  Row,
  CardBody,
  CardTitle,
  Label,
  Input,
  Container,
} from "reactstrap"

const BankDetails = () => {
  const { kycData, isLoading, user } = useFetchKycData()

  return (
    <div className="page-content">
      <Container fluid>
        {isLoading && <FullPageLoader />}

        <Breadcrumb title={"Bank Details"} />
        {!isLoading && user?.status === "APPROVED" && kycData && (
          <div>
            <Card>
              <CardBody>
                <Row>
                  <Col xl={12}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Account Holders Name
                        </Label>
                        <Input
                          disabled
                          name="account_holder"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsBankDetails?.account_holder}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Account Number</Label>
                        <Input
                          disabled
                          name="account_no"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsBankDetails?.account_no}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Bank Name</Label>
                        <Input
                          disabled
                          name="bank_name"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsBankDetails?.bank_name}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">IFSC</Label>
                        <Input
                          disabled
                          name="ifsc"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsBankDetails?.ifsc}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Account Type</Label>
                        <Input
                          disabled
                          name="ifsc"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsBankDetails?.account_type}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        )}
      </Container>
    </div>
  )
}

export default BankDetails
